import { Construction } from "lucide-react";

const UnderConstruction = () => {
  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center space-y-4 text-center">
      <Construction className="h-16 w-16 animate-bounce text-yellow-500" />
      <h1 className="text-2xl font-bold">Page Under Construction</h1>
      <p className="text-muted-foreground max-w-md">
        We're working hard to bring you an amazing reporting experience. This
        feature will be available soon!
      </p>
      <div className="flex items-center gap-2">
        <div className="h-2 w-2 animate-pulse rounded-full bg-blue-500" />
        <div className="h-2 w-2 animate-pulse rounded-full bg-yellow-500 delay-150" />
        <div className="h-2 w-2 animate-pulse rounded-full bg-red-500 delay-300" />
      </div>
    </div>
  );
};

export default UnderConstruction;
